function lowerKeySet(list = []) {
  return new Set(
    (Array.isArray(list) ? list : [])
      .map(item => String(item || '').trim().toLowerCase())
      .filter(Boolean)
  );
}

export function subtractProgressKeys(keys = [], removeKeys = []) {
  const drop = lowerKeySet(removeKeys);
  if (!drop.size) {
    return (Array.isArray(keys) ? keys : [])
      .map(item => String(item || '').trim())
      .filter(Boolean);
  }
  return (Array.isArray(keys) ? keys : [])
    .map(item => String(item || '').trim())
    .filter(item => item && !drop.has(item.toLowerCase()));
}

export function constraintMemoryKey(constraint, index = 0) {
  const id = String(constraint?.id || '').trim();
  if (id) return id;
  const kind = String(constraint?.kind || '').trim().toLowerCase();
  const slot = String(constraint?.slot || '').trim().toLowerCase();
  const claim = String(constraint?.claim || constraint?.value || '').trim().toLowerCase();
  return `anon:${index}:${kind}:${slot}:${claim.slice(0, 60)}`;
}

export function constraintDisplayText(constraint) {
  return String(constraint?.claim || constraint?.value || '').trim();
}

export function constraintKindLabelKey(constraint) {
  const kind = String(constraint?.kind || '').trim().toLowerCase();
  if (kind === 'decision') return 'constraintKindDecision';
  if (kind === 'constraint') return 'constraintKindConstraint';
  if (kind === 'assumption') return 'constraintKindAssumption';
  if (kind === 'open') return 'constraintKindOpen';
  return 'constraintKindFact';
}

/**
 * Settings-modal edits: drop not-interested / solved marks and delete or
 * deactivate constraints/claims. Restoring a not-interested gap also un-solves it.
 */
export function editContextMemory(recs, {
  removeNotInterestedKeys = [],
  removeDoneBlockerKeys = [],
  removeDoneValidationKeys = [],
  deleteConstraintKeys = [],
  setConstraintActive = null,
} = {}) {
  if (!recs || typeof recs !== 'object') return recs || null;
  const progress = recs.userProgress && typeof recs.userProgress === 'object'
    ? recs.userProgress
    : {};
  const niRemove = (Array.isArray(removeNotInterestedKeys) ? removeNotInterestedKeys : [])
    .map(item => String(item || '').trim())
    .filter(Boolean);
  const doneRemove = [
    ...(Array.isArray(removeDoneBlockerKeys) ? removeDoneBlockerKeys : []),
    ...niRemove,
  ].map(item => String(item || '').trim()).filter(Boolean);
  const validationRemove = (Array.isArray(removeDoneValidationKeys) ? removeDoneValidationKeys : [])
    .map(item => String(item || '').trim())
    .filter(Boolean);

  const nextProgress = {
    ...progress,
    notInterestedKeys: subtractProgressKeys(progress.notInterestedKeys, niRemove),
    doneBlockerKeys: subtractProgressKeys(progress.doneBlockerKeys, doneRemove),
    doneValidationKeys: subtractProgressKeys(progress.doneValidationKeys, validationRemove),
  };

  const dropDone = lowerKeySet(doneRemove);
  if (dropDone.size && Array.isArray(progress.doneFills)) {
    nextProgress.doneFills = progress.doneFills.filter(entry => (
      !dropDone.has(String(entry?.doneKey || '').trim().toLowerCase())
    ));
  }
  const dropValidation = lowerKeySet(validationRemove);
  if (dropValidation.size && Array.isArray(nextProgress.doneFills)) {
    nextProgress.doneFills = nextProgress.doneFills.filter(entry => (
      entry?.kind !== 'validation'
      || !dropValidation.has(String(entry?.doneKey || '').trim().toLowerCase())
    ));
  }

  let constraints = Array.isArray(recs.constraints) ? recs.constraints.slice() : [];
  const deleteSet = new Set(
    (Array.isArray(deleteConstraintKeys) ? deleteConstraintKeys : []).map(item => String(item || ''))
  );
  if (deleteSet.size) {
    constraints = constraints.filter((item, index) => (
      !deleteSet.has(constraintMemoryKey(item, index))
    ));
  }
  if (Array.isArray(setConstraintActive?.keys) && setConstraintActive.keys.length) {
    const toggleSet = new Set(setConstraintActive.keys.map(item => String(item || '')));
    const active = setConstraintActive.active !== false;
    constraints = constraints.map((item, index) => (
      toggleSet.has(constraintMemoryKey(item, index))
        ? { ...item, active }
        : item
    ));
  }

  return {
    ...recs,
    userProgress: nextProgress,
    constraints,
  };
}
